import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  LegendLabelsContentArgs,
  SeriesClickEvent,
  TooltipContext,
} from "@progress/kendo-react-charts";
import LoadingComponentOverlay from "components/LoadingComponentOverlay";
import "hammerjs";
import { useGetCategoryReport } from "hooks/queries";
import { useNavigate } from "react-router-dom";
import CategoryLegend from "./CategoryLegend";

export interface CategoryReport {
  category: string;
  value: number;
  color?: string;
}

export const seriesColors = [
  { category: "Facilities", color: "#357ab2" },
  { category: "General", color: "#bd5727" },
  { category: "Human Capital", color: "#8e704f" },
  { category: "Industrial Products & Services", color: "#3e8520" },
  { category: "Information Technology", color: "#6f7a41" },
  { category: "Medical", color: "#21827f" },
  { category: "Office Management", color: "#864381" },
  { category: "Professional Services", color: "#3f57a6" },
  { category: "Security & Protection", color: "#a23737" },
  { category: "Transportation & Logistics", color: "#003E73" },
  { category: "Travel", color: "#357ab2aa" },
];

// Category percentages was once asked for. Saving just in case for now.
// const labelContent = (props: any) => {
//   let formatedNumber = Number(props.dataItem.value).toLocaleString(undefined, {
//     style: "percent",
//     minimumFractionDigits: 2,
//   });
//   return `${props.dataItem.category} (${props.dataItem.value})`;
// };

// const SharedTooltip = (props: any) => {
//   const { point } = props;

//   return (
//     <div>
//       {point && (
//         <div>
//           {point.category} : {point.value}
//         </div>
//       )}
//     </div>
//   );
// };

const defaultTooltipRender = (props: TooltipContext) => {
  const { point } = props;
  return point ? `${point.category}: ${point.value}` : "";
};

const CategoryReport = () => {
  // Hooks
  const navigate = useNavigate();
  const { data, isLoading } = useGetCategoryReport();

  // Functions
  const result: CategoryReport[] =
    data &&
    data.map((v: CategoryReport) => ({
      ...v,
      ...seriesColors.find((sp) => sp.category === v.category),
    }));

  const labelContent = (e: LegendLabelsContentArgs) =>
    `${e.text} (${e.percentage?.toLocaleString(undefined, {
      style: "percent",
      minimumFractionDigits: 1,
    })})`;

  // Render
  if (isLoading)
    return (
      <LoadingComponentOverlay active={isLoading}>
        <h1 className="h3">RFIs by Category</h1>
        <div className="text-center">
          <Chart>
            <ChartSeries>
              <ChartSeriesItem
                type="pie"
                data={[]}
                field="value"
                categoryField="category"
              >
                <ChartSeriesItemTooltip
                  visible={true}
                  render={defaultTooltipRender}
                />
              </ChartSeriesItem>
            </ChartSeries>
          </Chart>
        </div>
      </LoadingComponentOverlay>
    );

  return (
    <>
      <h1 className="h3">RFIs by Category</h1>
      <div className="text-center">
        <Chart
          onSeriesClick={(props: SeriesClickEvent) => {
            console.log("clickProps", props.dataItem);
            navigate("/RfiList", {
              state: { category: props.dataItem.category },
            });
          }}
        >
          <ChartLegend
            visible={false}
            position="bottom"
            labels={{
              content: labelContent,
            }}
          />

          <ChartSeries>
            <ChartSeriesItem
              type="pie"
              data={result}
              field="value"
              categoryField="category"
              labels={{ visible: false, content: labelContent }}
            >
              <ChartSeriesItemTooltip
                visible={true}
                render={defaultTooltipRender}
              />
            </ChartSeriesItem>
          </ChartSeries>
        </Chart>
      </div>
      <CategoryLegend data={result}></CategoryLegend>
    </>
  );
};

export default CategoryReport;
